import { render, staticRenderFns } from "./ContractChanges.vue?vue&type=template&id=5f761974&scoped=true&lang=pug"
import script from "./ContractChanges.vue?vue&type=script&lang=js"
export * from "./ContractChanges.vue?vue&type=script&lang=js"
import style0 from "./ContractChanges.vue?vue&type=style&index=0&id=5f761974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f761974",
  null
  
)

export default component.exports